import { styled } from 'styled-components';
import { colors } from '../../../../abstracts';
const StyledDescriptionDetails = styled.dd.withConfig({
  componentId: "aui__sc-124ckwb-0"
})(["margin:0;color:", ";padding-top:0.25rem;"], colors.neutralDeeper);
export { StyledDescriptionDetails };